module.exports = __webpack_public_path__ + "fonts/Lato-300-3.0a34f21.woff2";